import { DomainModelHelper } from '@digital-platform/shared/domain';
import { SignNowSubscription } from '../interfaces/subscription.interface';

export class SignNowSubscriptionModel implements SignNowSubscription {
  public constructor(data?: SignNowSubscription) {
    Object.assign(this, SignNowSubscriptionModel.DEFAULT_CONFIG);

    if (data?.id !== undefined) {
      this.id = DomainModelHelper.ensureDataIsString(data.id);
    }
    if (data?.event !== undefined) {
      this.event = DomainModelHelper.ensureDataIsString(data.event);
    }
    if (data?.entity_id !== undefined) {
      this.entity_id = DomainModelHelper.ensureDataIsNumber(data.entity_id);
    }
    if (data?.entity_unique_id !== undefined) {
      this.entity_unique_id = DomainModelHelper.ensureDataIsString(
        data.entity_unique_id
      );
    }
    if (data?.action !== undefined) {
      this.action = DomainModelHelper.ensureDataIsString(data.action);
    }
    if (data?.json_attributes?.use_tls_12 !== undefined) {
      this.json_attributes = {
        ...this.json_attributes,
        use_tls_12: DomainModelHelper.ensureDataIsBoolean(
          data.json_attributes.use_tls_12
        ),
      };
    }
    if (data?.json_attributes?.docid_queryparam !== undefined) {
      this.json_attributes = {
        ...this.json_attributes,
        docid_queryparam: DomainModelHelper.ensureDataIsBoolean(
          data.json_attributes.docid_queryparam
        ),
      };
    }
    if (data?.json_attributes?.callback_url !== undefined) {
      this.json_attributes = {
        ...this.json_attributes,
        callback_url: DomainModelHelper.ensureDataIsString(
          data.json_attributes.callback_url
        ),
      };
    }
    if (data?.application_name !== undefined) {
      this.application_name = DomainModelHelper.ensureDataIsString(
        data.application_name
      );
    }
    if (data?.created !== undefined) {
      this.created = DomainModelHelper.ensureDataIsNumber(data.created);
    }
  }

  public static DEFAULT_CONFIG: SignNowSubscription = {
    id: null,
    event: null,
    entity_id: null,
    entity_unique_id: null,
    action: null,
    json_attributes: {
      use_tls_12: null,
      docid_queryparam: null,
      callback_url: null,
    },
    application_name: null,
    created: null,
  };

  public readonly id: string;
  public readonly event: string;
  public readonly entity_id: number;
  public readonly entity_unique_id: string;
  public readonly action: string;
  public readonly json_attributes: {
    readonly use_tls_12: boolean;
    readonly docid_queryparam: boolean;
    readonly callback_url: string;
  };
  public readonly application_name: string;
  public readonly created: number;
}
